import { render, staticRenderFns } from "./MailAttachment.vue?vue&type=template&id=6fb50630&scoped=true"
import script from "./MailAttachment.vue?vue&type=script&lang=js"
export * from "./MailAttachment.vue?vue&type=script&lang=js"
import style0 from "./MailAttachment.vue?vue&type=style&index=0&id=6fb50630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb50630",
  null
  
)

export default component.exports